<template>
	<b-icon :icon="this.icon" size=""></b-icon>
</template>

<script>
export default {
	name: 'SegmentIcon',
	props: {
		segment: Object,
        type: String
	},
    computed: {
        icon_type(){
            return this.type ?? this.segment?.type ?? null;
        },
        icon() {
            if( this.icon_type === 'air') return 'airplane'
            if( this.icon_type === 'car') return 'car-hatchback'
            if( this.icon_type === 'hotel') return 'bed'
            return 'wallet-travel'
        }
    },
	methods: {

	},
    mounted() {},
}
</script>


<style scoped>

</style>
